module.exports = __webpack_public_path__ + "a8a10a3e/img/cadBim.e369a02a.png";